import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import { getSpacing } from "@faire/web--source/slate/spacing";
import {
  Typography,
  TypographyStyles,
} from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackHelpCenterBreadcrumbClick } from "@faire/web-api--source/events/helpCenter/click/breadcrumb";
import React from "react";
import styled from "styled-components";

import { ILinkData } from "./types";

export const HeaderBreadcrumbs: React.FC<{ breadcrumbPaths: ILinkData[] }> = ({
  breadcrumbPaths,
}) => {
  const handleBreadcrumbClick = (pathName: string) => {
    trackHelpCenterBreadcrumbClick(
      pathName,
      getRetailerToken() ?? "",
      getBrandToken() ?? ""
    );
  };
  if (getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment()) {
    return (
      <BreadcrumbWrapper>
        {breadcrumbPaths.map((path, index) => {
          return (
            <React.Fragment key={path.name}>
              {index ? <Slash /> : null}
              <BreadcrumbLink
                as={Link}
                to={path.to!}
                onClick={() => handleBreadcrumbClick(path.name)}
              >
                <Typography>{path.name}</Typography>
              </BreadcrumbLink>
            </React.Fragment>
          );
        })}
      </BreadcrumbWrapper>
    );
  }

  return (
    <Breadcrumb>
      {breadcrumbPaths.map((path, index) => {
        const isLast = index === breadcrumbPaths.length - 1;
        return (
          <React.Fragment key={path.name}>
            {index ? <Slash /> : null}
            {isLast ? (
              <BreadcrumbText
                color={Core.text.subdued}
                onClick={() => handleBreadcrumbClick(path.name)}
              >
                {path.name}
              </BreadcrumbText>
            ) : (
              <BreadcrumbLink
                as={Link}
                to={path.to!}
                onClick={() => handleBreadcrumbClick(path.name)}
              >
                <Typography>{path.name}</Typography>
              </BreadcrumbLink>
            )}
          </React.Fragment>
        );
      })}
    </Breadcrumb>
  );
};

const BreadcrumbWrapper = styled.div`
  display: flex;
  overflow: hidden;
  max-width: 100%;
  flex: 1;
`;

const Breadcrumb = styled.div`
  display: flex;
  overflow: hidden;
  max-width: 100%;
  flex: 1;
`;

const BreadcrumbLink = styled.div`
  position: relative;
  white-space: nowrap;
  &:hover:after {
    content: "";
    display: block;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: ${Core.surface.hover};
  }
`;

const BreadcrumbText = styled(Typography).attrs({
  truncate: true,
})`
  position: relative;
  flex: 1;
  max-width: 100%;
`;

const Slash = styled.span`
  &:before {
    ${TypographyStyles({ color: Core.text.subdued })}
    display: inline-block;
    padding: ${getSpacing(0, "1x")};
    content: "/";
    vertical-align: top;
  }
`;
